import TransactionsTableSkeleton from './transactions-table.skeleton'
import { useNavigate } from 'react-router'
import { ROUTE_TRANSACTIONS, ROUTE_TRANSACTIONS_ALL_TRANSACTIONS } from '../../routes/paths'
import useGetPendingTransactions from '../hooks/use-get-pending-transactions'
import PendingTransactionsTable from '../transactions-page/tabs/all-transactions/pending-transactions-table'
import PostedTransactionsTable from '../transactions-page/tabs/all-transactions/posted-transactions-table '
import { Button } from '@/components'
import { useGetPostedTransactions } from '../hooks/use-get-posted-transactions'

const TransactionsTable = () => {
  const navigate = useNavigate()
  const { data: trData } = useGetPostedTransactions() || []
  const { data: pendingTransactionsData } = useGetPendingTransactions()
  const postedTransactions = trData?.pages?.flatMap(page => page.transactions) || []
  const pendingTransactions = pendingTransactionsData?.node?.financialAccountActivities?.edges || []

  return (
    <div className="w-full h-auto py-8 px-4 md:px-5">
      <div className="px-0">
        {!pendingTransactions ? (
          <TransactionsTableSkeleton />
        ) : (
          <PendingTransactionsTable data={pendingTransactions} page="home" />
        )}
        <div className=" px-0 md:-px-2">
          <PostedTransactionsTable data={postedTransactions} page="home" />
        </div>
      </div>
      <div className={`${postedTransactions?.length > 0 ? 'mt-8' : 'mt-20 '} w-full flex flex-row justify-center `}>
        <Button
          id="recent-transactions-view-all-button"
          aria-label="View all"
          onClick={() => {
            navigate(`/${ROUTE_TRANSACTIONS}${ROUTE_TRANSACTIONS_ALL_TRANSACTIONS}`)
            window.scrollTo(0, 0) // scroll to top of transactions page
          }}
          className="w-[250px] bg-brand-600 hover:bg-brand-700 my-4 md:my-0 text-md font-semibold"
        >
          View all
        </Button>
      </div>
    </div>
  )
}

export default TransactionsTable
